import React from 'react';

import {BlockSkeleton} from '@udemy/react-reveal-components';

import styles from './plan-catalog-preview-skeleton.module.less';

/**
 * ### PlanCatalogPreviewSkeleton
 *
 * Loading state for the catalog preview. A single rounded block that reserves the
 * same footprint as the loaded card, so the page does not shift when it resolves.
 */
export const PlanCatalogPreviewSkeleton = () => (
    <div className={styles['block']} data-testid="plan-catalog-preview-skeleton">
        <BlockSkeleton className={styles['fill']} />
    </div>
);
